import { render } from "./ArmourCompendiumModal.vue?vue&type=template&id=74716f9b"
import script from "./ArmourCompendiumModal.vue?vue&type=script&lang=js"
export * from "./ArmourCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__